import { useState } from "react";
import { FaSearchPlus } from "react-icons/fa";
import "../../styles/art/TrainingCooperationSection.css";

const images = Array.from(
  { length: 18 },
  (_, i) => `/images/cooperation/${i + 1}.webp`
);

function TrainingCooperationSection() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (src) => setSelectedImage(src);
  const closeLightbox = () => setSelectedImage(null);

  return (
    <section className="training-cooperation-section--art section-container">
      <h2 className="section-title">Các hoạt động hợp tác đào tạo</h2>

      <div className="cooperation-grid">
        {images.map((src, index) => (
          <div
            className="cooperation-image-box"
            key={index}
            onClick={() => openLightbox(src)}
          >
            <img
              src={src}
              alt={`cooperation-${index + 1}`}
              className="cooperation-image"
            />
            <div className="cooperation-overlay">
              <FaSearchPlus className="overlay-icon" />
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="lightbox"
          onClick={closeLightbox}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="cooperation-full"
            />
            <button
              className="lightbox-close"
              onClick={closeLightbox}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default TrainingCooperationSection;
